import React, { useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { slideIn } from './Variants'
import { EarthCanvas } from './canvas'
import { styles } from '../../styles'

const Contact = () => {
  
  const [loading, setLoading] = useState(false);

  return (
    <div
    className={`xl:mt-12 flex justify-center rounded-3xl xl:flex-row mb-5 flex-col-reverse gap-10 overflow-hidden`}
  >
    <motion.div
      variants={slideIn("left", "tween", 0.2, 1)}
      className='flex-[0.75] bg-black-100 p-8 rounded-2xl'
    >
      <p className={styles.sectionSubText}>Get in touch</p>
      <h3 className={styles.sectionHeadText}>Contact.</h3>

      <form
       action="https://getform.io/f/498aa582-496e-41e9-950b-3e2ff4c93bf7" method="POST" enctype="multipart/form-data"
        className='mt-12 flex flex-col gap-8'
      >
        <label className='flex flex-col'>
          <span className='text-white font-medium mb-4'>Your Name</span>
          <input
            type='text'
            name='name'
            placeholder="What's your good name?"
            className='bg-tertiary py-4 px-6 placeholder:text-primary text-white rounded-lg outline-none border-none font-medium'
          />
        </label>
        <label className='flex flex-col'>
          <span className='text-white font-medium mb-4'>Your email</span>
          <input
            type='email'
            name='email'
            placeholder="What's your web address?"
            className='bg-tertiary py-4 px-6 placeholder:text-primary text-white rounded-lg outline-none border-none font-medium'
          />
        </label>
        <label className='flex flex-col'>
          <span className='text-white font-medium mb-4'>Your Message</span>
          <textarea
            rows={7}
            name='message'
            placeholder='What you want to say?'
            className='bg-tertiary py-4 px-6 placeholder:text-primary text-white rounded-lg outline-none border-none font-medium'
          />
        </label>

        <button
          type='submit'
          className='bg-tertiary py-3 px-8 rounded-xl outline-none w-fit text-white font-bold shadow-md shadow-primary'
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </form>
    </motion.div>
    </div>
  )
}

export default Contact